export declare namespace AppRoutedTabsListTokenSections {
	interface Vertical {
		gap: string;
		item: {
			padding: string;
			borderRadius: string;
			color: string;
			fontSize: string;
			lineHeight: string;
			fontWeight: string;
			iconSize: string;
			hoverBackground: string;
			activeBackground: string;
			activeColor: string;
			activeFontWeight: string;
		};
	}
}

export type AppRoutedTabsListTokens = {
	vertical: AppRoutedTabsListTokenSections.Vertical;
};

export const vertical: AppRoutedTabsListTokenSections.Vertical = {
	gap: '0.125rem',
	item: {
		padding: '0.625rem 0.75rem',
		borderRadius: '{border.radius.lg}',
		color: '{surface.700}',
		fontSize: '{app.sm.font.size}',
		lineHeight: '{app.sm.line.height}',
		fontWeight: '500',
		iconSize: '1.125rem',
		hoverBackground: '{surface.50}',
		activeBackground: '{highlight.background}',
		activeColor: '{primary.color}',
		activeFontWeight: '700',
	},
};

export default {
	vertical,
} satisfies AppRoutedTabsListTokens;
